import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import "./WelcomeScreen.css";
import logo from "../assets/logo.png";
import cardImage from "../assets/card.png";
import Map from "../components/Map";
import { db } from "../firebase"; // Import Firestore

const WelcomeScreen = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const [user, setUser] = useState(null);
  const [workspace, setWorkspace] = useState("Default Workspace");
  const [locations, setLocations] = useState([
    { id: "1", name: "Screen 1", lat: 43.8563, lng: 18.4131, status: "Online" },
    { id: "2", name: "Screen 2", lat: 44.1194, lng: 17.9077, status: "Offline" },
    { id: "3", name: "Screen 3", lat: 43.3438, lng: 17.8086, status: "Online" },
  ]);

  // Fetch user and workspace details
  useEffect(() => {
    const fetchUserData = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        setUser({ email: currentUser.email });

        // Fetch workspace from Firestore
        const docRef = doc(db, "users", currentUser.email);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setWorkspace(data.workspaces?.[0] || "Default Workspace");
        }
      }
    };

    fetchUserData();
  }, [auth]);

  // Logout function
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
  };

  const screenStats = {
    registered: locations.length,
    online: locations.filter((screen) => screen.status === "Online").length,
    offline: locations.filter((screen) => screen.status === "Offline").length,
  };

  return (
    <div className="welcome-screen">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="project-logo" />
        </div>
        <div className="user-info">
          
          <span className="bell-icon">🔔</span>
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="welcome-message">
        <h1>{user?.email || "Guest"}</h1>
        <p>{workspace}</p>
      </div>

      {/* Cards Section */}
      <div className="cards-section">
        {[
          { title: "Screens", image: cardImage, link: "/screens" },
          { title: "Content", image: cardImage, link: "/content" },
          { title: "Playlists", image: cardImage, link: "/playlists" },
          { title: "Schedules", image: cardImage, link: "/schedules" },
        ].map((card, index) => (
          <div className="card" key={index} onClick={() => navigate(card.link)}>
            <img src={card.image} alt={card.title} className="card-image" />
            <h2>{card.title}</h2>
            <button className="add-button">+</button>
          </div>
        ))}
      </div>

      {/* Map Section */}
      <div className="map-section">
        <div className="map-container">
          <Map locations={locations} />
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
